import axios, { AxiosInstance } from "axios";

export const $http: AxiosInstance = axios.create({
    baseURL: process.env.VUE_APP_ENTERPRISE_VACAN_ADAPTER_API_BASE_URL,
    timeout: 10000,
});
